/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_VideoInputs */

const en_player_no_video = /** @type {(inputs: Player_No_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No video available`)
};

const ja_player_no_video = /** @type {(inputs: Player_No_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用できる動画がありません`)
};

const fr_player_no_video = /** @type {(inputs: Player_No_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de vidéo disponible`)
};

const de_player_no_video = /** @type {(inputs: Player_No_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Video verfügbar`)
};

/**
* | output |
* | --- |
* | "No video available" |
*
* @param {Player_No_VideoInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_no_video = /** @type {((inputs?: Player_No_VideoInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_VideoInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_no_video(inputs)
	if (locale === "ja") return ja_player_no_video(inputs)
	if (locale === "fr") return fr_player_no_video(inputs)
	return de_player_no_video(inputs)
});